// The catalogue's addresses (UC-30, UC-31). Search, paging and the shop are
// part of the address, so every page of the catalogue and every shop's menu
// has a URL of its own, which a search engine can follow and a diner share.

/** The home, with the search and the page when they are not the defaults. */
export function homeHref(query: string, page: number): string {
	const params = new URLSearchParams();
	const q = query.trim();
	if (q) params.set('q', q);
	if (page > 1) params.set('page', String(page));
	const search = params.toString();
	return search ? `/?${search}` : '/';
}

/** A restaurant's page, with ?shop= for any shop but the first. */
export function shopHref(slug: string, shop: string): string {
	const page = `/${encodeURIComponent(slug)}`;
	return shop ? `${page}?shop=${encodeURIComponent(shop)}` : page;
}

/** Reads ?page=, falling back to the first page for anything but a whole number from 1. */
export function pageFrom(raw: string | null): number {
	const page = Number(raw ?? '1');
	return Number.isInteger(page) && page >= 1 ? page : 1;
}

// The shape of a restaurant's address, as core's ValidSlug allows it.
const SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** The restaurant a path names, /<slug>, or '' for any other path. */
export function slugFromPath(pathname: string): string {
	const segment = /^\/([^/]+)\/?$/.exec(pathname)?.[1] ?? '';
	return SLUG.test(segment) ? segment : '';
}

/**
 * The website for restaurant owners: www beside this catalogue's menu host,
 * so no hostname is written here.
 */
export function ownersHref(catalogue: URL): string {
	const host = catalogue.hostname.replace(/^menu\./, 'www.');
	return host === catalogue.hostname ? '/' : `${catalogue.protocol}//${host}/`;
}
